import React, { useEffect } from "react";
import "./Sidebar.css";
import { Link, useNavigate } from "react-router-dom";
import { UserRoundPlus, UserRoundCheck } from "lucide-react";

import TravelAgency from "../../assets/travel-agency.svg";
import Home from "../../assets/home.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import Cancel from "../../assets/cancel.svg";

const SidebarClient = ({ menuOpen, setMenuOpen }) => {
  const navigate = useNavigate();
  const handleCloseMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (menuOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  return (
    <>
      <div
        className={`mobile-overlay ${menuOpen ? "show" : ""}`}
        onClick={handleCloseMenu}
      />

      <aside className={`sidebar ${menuOpen ? "open" : "closed"}`}>
        <button
          className="desktop-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? "❮" : "❯"}
        </button>

        <nav>
          <ul>
            <li
              className="active"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-client");
              }}
            >
              <img src={Home} className="sidebar-icon" alt="" />
              Início
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/trips-progress-client");
              }}
            >
              <img src={EmAndamento} className="sidebar-icon" alt="" />
              Solicitações em Andamento
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/trips-concluded-client");
              }}
            >
              <img src={TravelAgency} className="sidebar-icon" alt="" />
              Encomendas Enviadas
            </li>

            <li onClick={handleCloseMenu}>
              <img src={Cancel} className="sidebar-icon" alt="" />
              Encomendas não Efetivadas
            </li>

            <div className="sidebar-section-title">PAINEIS DE CONTROLE</div>

            <li
              className="special-panel panell"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-traveler");
              }}
            >
              <div className="panel-icon-wrapper">
                <UserRoundPlus
                  size={34}
                  strokeWidth={2.5}
                  className="tag-icon"
                />
              </div>

              <div className="panel-text">
                <strong>Painel do Viajante</strong>
              </div>
            </li>

            <li
              className="special-panel panell"
              onClick={() => {
                handleCloseMenu();
                navigate("/dashboard-receiver");
              }}
            >
              <div className="panel-icon-wrapper">
                <UserRoundCheck
                  size={34}
                  strokeWidth={2.5}
                  className="tag-icon"
                />
              </div>

              <div className="panel-text">
                <strong>Painel do Destinatário</strong>
              </div>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default SidebarClient;
